import { styled } from 'shared/Houston';

export const Title = styled.h1`
  text-transform: capitalize;
  margin: 0;
  font-size: 24px;
  line-height: 1.5;
  font-weight: 600;
  color: ${({ theme }) => theme.neutralColor.low.dark};
`;
